function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1Pfeil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.75 12.75",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "s1pfeil_5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.82762,9.9861a4.00988,4.00988,0,0,0,3.10156-.00293L6.375,11.88942Z",
    style: {
      fill: "#0abae6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57,10.23775,6.37526,11.70351,5.185,10.23928a4.12268,4.12268,0,0,0,2.385-.00153m.8011-.61066a3.87911,3.87911,0,0,1-3.98288.0047L6.375,12.076,8.37114,9.62709Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12.75,
    height: 12.75,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1Pfeil);
export default __webpack_public_path__ + "static/media/s1pfeil.044cb134309dfc8505624def5ee8bfaa.svg";
export { ForwardRef as ReactComponent };